import React from "react";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

function AddOption({
  index,
  addOption,
  question,
  handleOptionChange,
  deleteOption,
}) {
  return (
    <React.Fragment>
      {question.questionType === "Range Type" ? (
        <React.Fragment>
          <div className="field col md:col-3 sm:col-12">
            <label htmlFor="option" className="label p-inputgroup">
              Options:{" "}
            </label>

            <InputText
              name="option"
              type="number"
              placeholder="Min"
              value={question.options[0].minRange}
              onChange={(e) => handleOptionChange(e, 0, index)}
              required
            />
          </div>
          <div
            className="field col md:col-3 sm:col-12"
            style={{ marginTop: "2.1rem" }}
          >
            <InputText
              name="option"
              type="number"
              placeholder="Max"
              value={question.options[0].maxRange}
              onChange={(e) => handleOptionChange(e, 1, index)}
              required
            />
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="field col md:col-3 sm:col-12">
            <label htmlFor="option" className="label p-inputgroup">
              Options:{" "}
              <Button
                icon="pi pi-plus"
                className="btn-primary"
                onClick={(e) => addOption(index)}
                type="button"
              />
            </label>
            <div className="p-inputgroup">
              <div className="p-inputgroup">
                {question.questionType === "Radio Type" ? (
                  <span className="p-inputgroup-addon">
                    <RadioButton />
                  </span>
                ) : (
                  <span className="p-inputgroup-addon">
                    <Checkbox />
                  </span>
                )}

                <InputText
                  name="option"
                  type="text"
                  value={question.options[0].optionText}
                  onChange={(e) => handleOptionChange(e, 0, index)}
                  required
                />
                {
                  (question.options.length>2) &&
                  <Button
                    onClick={(e) => deleteOption(0, index)}
                    icon="pi pi-trash"
                    className=" p-button-danger"
                    type="button"
                  />
                }
              </div>
            </div>
          </div>
          {question.options.slice(1).map((option, id) => (
            <div
              className="field col md:col-3 sm:col-12"
              key={id}
              style={{ marginTop: "3rem" }}
            >
              <div className="p-inputgroup">
                {question.questionType === "Radio Type" ? (
                  <span className="p-inputgroup-addon">
                    <RadioButton />
                  </span>
                ) : (
                  <span className="p-inputgroup-addon">
                    <Checkbox />
                  </span>
                )}

                <InputText
                  name={`option[${id + 1}]`}
                  type="text"
                  value={option.optionText}
                  onChange={(e) => handleOptionChange(e, id + 1, index)}
                  required
                />

                {
                  (id>0 || question.options.length>2) &&
                  <Button
                    onClick={(e) => deleteOption(id + 1, index)}
                    icon="pi pi-trash"
                    className=" p-button-danger"
                    type="button"
                  />
                }
              </div>
            </div>
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default AddOption;
